import type { OdReviewIssue } from "../../../services/odReview/odReview.types";

export const isPhotoIssue = (issue: OdReviewIssue): boolean =>
  issue.error_type === "FOTO_INCORRECTA" || issue.target_field === "photo";

export interface ResourceProvenance {
  pageNumber: number;
  resourceFileId: number;
  resourceId: number | null;
  citedReference: string | null;
}

export function readResourceProvenance(
  issue: OdReviewIssue,
): ResourceProvenance | null {
  if (issue.resolved_page_number === null) return null;
  if (issue.resource_file_id === null) return null;
  return {
    pageNumber: issue.resolved_page_number,
    resourceFileId: issue.resource_file_id,
    resourceId: issue.resource_id,
    citedReference: issue.resource_reference,
  };
}

export function formatResourceProvenance(
  provenance: ResourceProvenance,
): string {
  const base = `Verificado contra la página física ${provenance.pageNumber} del archivo #${provenance.resourceFileId}`;
  if (provenance.resourceId === null) return base;
  return `${base} · recurso #${provenance.resourceId}`;
}

export function formatCitedReference(
  provenance: ResourceProvenance,
): string | null {
  if (provenance.citedReference === null) return null;
  const trimmed = provenance.citedReference.trim();
  if (trimmed === "") return null;
  return `Referencia citada en el OD: «${trimmed}»`;
}
